import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy, useEffect } from 'react';
import ResourcePreloader from './components/ResourcePreloader';
import './App.css';
import { useLocation } from 'react-router-dom';
import { pageview } from './lib/analytics';

// Lazy load pages for code splitting
const Home = lazy(() => import('./pages/Home'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Services = lazy(() => import('./pages/Services'));
const Contact = lazy(() => import('./pages/Contact'));

// Optimized loading component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen bg-gauss-dark">
    <div className="w-8 h-8 border-2 border-gauss-accent/30 border-t-gauss-accent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <div className="App w-full">
      <ResourcePreloader />
      <Router>
        {/* Analytics listener: send page_view to GA4 on route change */}
        <AnalyticsListener />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

const AnalyticsListener: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // send a page_view to GA when route changes
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
};

export default App;
